export default "__VITE_ASSET__9ed50737__"